import React from 'react'
import PropTypes from 'prop-types'

import TableSplitButton from '~/components/TableSplitButton/TableSplitButton'
import useDeleteConfirm from '~/components/TableSplitButton/useDeleteConfirm'

function BulkActionButton ({ onProductsDelete, loading }) {
  const { handleClick } = useDeleteConfirm()

  const options = [
    {
      label: 'Delete',
      'data-cy': 'deleteMenu',
      onMenuClick: () => handleClick(onProductsDelete)
    }
  ]

  return (
    <TableSplitButton
      options={options}
      name="product"
      loading={loading}
    />
  )
}

BulkActionButton.propTypes = {
  onProductsDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default BulkActionButton
